import axios from 'axios';
import { showDialog   } from 'vant';
// import store from '@/store/index.ts';

// 设置接口超时时间
axios.defaults.timeout = 60000;

// 请求地址，这里是动态赋值的的环境变量，下一篇会细讲，这里跳过
// @ts-ignore  
axios.defaults.baseURL = '';
var ueBaseUrl = process.env.VUE_APP_BASE_URL_UE; //ue接口地址
var lineBaseUrl = process.env.VUE_APP_BASE_URL; //line接口地址
//http request 拦截器
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
      config.headers = {
        'token': token,
      };  
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//http response 拦截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const {response} = error;
    if (response) {
      // 请求已发出，但是不在2xx的范围
      return Promise.reject(response.data);
    } else {
      showDialog(
        {
          message: '網絡連接異常,請稍後再試!',
          theme: 'round-button',
        }).then(() => {
        // on close
      });
    }
  }
);

//通用方法
export const post = (url, params) =>  {
  url = geturl(url);
    const getTimestamp = new Date().getTime();
    return axios.post(`${url}?timer=${getTimestamp}`, params,{
      headers:{
        'Content-Type':'application/json;charset=UTF-8'
      }
    }).then((res) => res.data);
}

//通用方法
export const post2 = (url, params) =>  {
  url = geturl(url);
  const getTimestamp = new Date().getTime();
  return axios.post(`${url}?timer=${getTimestamp}`, params,{
    headers:{
      'Content-Type':'multipart/form-data'
    }
  }).then((res) => res.data);
}
 
export const get = (url, params) => {
  url = geturl(url);
  const getTimestamp = new Date().getTime();
  return axios.get(`${url}?timer=${getTimestamp}`, { params: params }).then((res) => res.data);
}
export const get2 = (url) => {
  url = geturl(url);
  return axios.get(`${url}`).then((res) => res.data);
} 
export const put = (url, params) => {
  url = geturl(url);
    return axios.put(`${url}`, params).then((res) => res.data);
}
 
export const del = (url, params) => {
  url = geturl(url);
  return axios.delete(`${url}`, { params: params }).then((res) => res.data);
}
 
export const patch = (url, params) =>{
  url = geturl(url);
  return axios.patch(`${url}`, params,{
    headers:{
      'Content-Type':'application/json;charset=UTF-8'
    }
  }).then((res) => res.data);
}
//通用方法
export const postue = (url, params) =>  {
  url = geturl(url);
  const getTimestamp = new Date().getTime();
  return axios.post(`${url}`, params, {
      headers:{
        'Content-Type':'application/json',        // 传参方式json
        'timestamp': getTimestamp,
      }
  }).then((res) => res.data);
}

//获取接口url
const geturl = (url) =>{
  if(url.indexOf('Auction') >= 0) {
    url = url.replace('Auction', ueBaseUrl + '/Auction')
  }else {
    url = url.replace('/api', lineBaseUrl + '/api')
  }
  return url;
}

export default axios